class PreOrderBanner extends HTMLElement {
  constructor() {
    super();
    
    // Create a shadow root
    this.attachShadow({ mode: 'open' });
  }

  static get observedAttributes() {
    return ['price', 'currency', 'compare-at-sale-price'];
  }

  connectedCallback() {
    this.render();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      this.render();
    }
  }

  shouldRender() {
    const price = this.getAttribute('price')?.trim();
    const currency = this.getAttribute('currency')?.trim();
    const sale_price = this.getAttribute('compare-at-sale-price')?.trim();
    return price && currency && sale_price;
  }

  render() {
    // Clear the shadow root if validation fails
    if (!this.shouldRender()) {
      this.shadowRoot.innerHTML = '';
      return;
    }

    const price = this.getAttribute('price').trim();
    const currency = this.getAttribute('currency').trim();
    const sale_price = this.getAttribute('compare-at-sale-price')?.trim();

    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
          font-family: 'Metropolis', system-ui, -apple-system, sans-serif;
        }
          
        .banner {
          background: rgba(12,12,12,32%);
          border-radius: 8px;
          padding: 7px 8px 10px;
          color: white;
        }
        @media screen and (orientation: portrait) and (max-width: 1081px) {
          .banner {
            margin-inline: -10px;
            padding: 7px 8px 8px;
          } 
        }

        .exclusive-tag {
          display: inline-block;
          background: linear-gradient(94.79deg, rgba(49, 178, 97, 0.3) 34.18%, rgba(255, 255, 255, 0.1) 65.82%);
          border-radius: 8px;
          padding: 4px 7px 2px 8px;
          font-size: 14px;
          font-weight: 600;
          line-height: 140%;
          color: white;
          margin-bottom: 4px;
        }

        .price-text {
          font-size: 12px;
          font-weight: 500;
          line-height: 120%;
          color: #bfbfbf;
          margin: 0 0 0 8px;
        }

        .price {
          font-size: 14px;
          font-weight: 600;
          line-height: 120%;
          color: #31B261;
        }
      </style>

      <div class="banner">
        <div class="exclusive-tag">Pre-order exclusive offer</div>
        <p class="price-text">
          Book this now for just <span class="price">${price}</span> instead of <span class="price">${sale_price}</span>
        </p>
      </div>
    `;
  }
}

// Register the custom element
customElements.define('pre-order-banner', PreOrderBanner);